module.exports = __webpack_public_path__ + "img/side-img.592eb64b.png";